var _excluded = ["prefix", "part", "dragMaskSelectType", "enableDragMaskReverseMode", "enableDragMask", "children", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { classnames } from '@okee-uikit/react-utils';
import { FrameSelectedType, useFrameSelect } from '../../../hooks/date';
import { useDragMask } from '../../../hooks/drag-mask';
import React, { useRef } from 'react';
import { usePrefixCls } from '@okee-uikit/react-config';
export function ViewFrameSelect(props) {
  var prefix = props.prefix,
      part = props.part,
      _props$dragMaskSelect = props.dragMaskSelectType,
      dragMaskSelectType = _props$dragMaskSelect === void 0 ? 'cover' : _props$dragMaskSelect,
      _props$enableDragMask = props.enableDragMaskReverseMode,
      enableDragMaskReverseMode = _props$enableDragMask === void 0 ? false : _props$enableDragMask,
      _props$enableDragMask2 = props.enableDragMask,
      enableDragMask = _props$enableDragMask2 === void 0 ? false : _props$enableDragMask2,
      children = props.children,
      className = props.className,
      extra = _objectWithoutProperties(props, _excluded);

  var ref = useRef(null);
  var maskRef = useRef(null);

  var _useFrameSelect = useFrameSelect(part),
      frameSelectDate = _useFrameSelect.frameSelectDate,
      frameSelectDateVirtual = _useFrameSelect.frameSelectDateVirtual;

  var negativeRef = useRef(false);
  useDragMask(ref, {
    draggable: enableDragMask,
    selectType: dragMaskSelectType,
    selectable: true,
    draggingSelectable: true,
    domKey: 'data-date-key',
    data: enableDragMaskReverseMode,
    onStart: function onStart(e) {
      if (e.negative) {
        negativeRef.current = true;
      }
    },
    onChange: function onChange(_ref) {
      var data = _ref.data,
          dragging = _ref.dragging,
          rect = _ref.rect,
          selected = _ref.selected;
      var m = maskRef.current;

      if (m != null) {
        m.style.display = dragging ? 'block' : 'none';
        m.style.left = "".concat(rect.left, "px");
        m.style.top = "".concat(rect.top, "px");
        m.style.width = "".concat(rect.width, "px");
        m.style.height = "".concat(rect.height, "px");
      }

      var dates = selected.map(function (item) {
        return new Date(+item);
      });

      if (dates.length) {
        frameSelectDateVirtual(dates, negativeRef.current ? FrameSelectedType.UNSELECT : data ? FrameSelectedType.REVERSE : FrameSelectedType.SELECT);
      }
    },
    onEnd: function onEnd(_ref2) {
      var data = _ref2.data,
          selected = _ref2.selected;
      var dates = selected.map(function (item) {
        return new Date(+item);
      });

      if (dates.length) {
        frameSelectDate(dates, negativeRef.current ? FrameSelectedType.UNSELECT : data ? FrameSelectedType.REVERSE : FrameSelectedType.SELECT);
      }

      negativeRef.current = false;
    }
  });
  var cls = classnames(usePrefixCls(prefix + '-view-frame'), className);
  var maskCls = usePrefixCls(prefix + '-view-frame-mask');
  return React.createElement("div", _objectSpread(_objectSpread({}, extra), {}, {
    className: cls,
    ref: ref
  }), children, React.createElement("div", {
    className: maskCls,
    ref: maskRef
  }));
}